import { Link } from "react-router-dom";

export const CheckoutButton = () => {
  return (
    <div className="checkout-button">
      <Link
        to="/OrderDetails"
        className="return-to-cart return-link d-none d-md-block"
      >
        <i className="fa-solid fa-chevron-left" /> Return to Cart
      </Link>
      <div className="button-effect">
        <button className="btn btn-products btn-addcart">Continue</button>
      </div>
    </div>
  );
};
